"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isDateInRange = void 0;
var date_fns_1 = require("date-fns");
/** Return `true` whether the given date is inside the range. */
function isDateInRange(date, range) {
    var _a;
    var from = range.from, to = range.to;
    if (!from) {
        return false;
    }
    if (!to && date_fns_1.isSameDay(from, date)) {
        return true;
    }
    if (!to) {
        return false;
    }
    var isToBeforeFrom = date_fns_1.differenceInCalendarDays(to, from) < 0;
    if (to && isToBeforeFrom) {
        _a = [to, from], from = _a[0], to = _a[1];
    }
    return (date_fns_1.differenceInCalendarDays(date, from) >= 0 &&
        date_fns_1.differenceInCalendarDays(to, date) >= 0);
}
exports.isDateInRange = isDateInRange;
//# sourceMappingURL=isDateInRange.js.map